import React from "react";
import "./HomeFeatures.css";

function HomeFeatures() {
  const features = [
    {
      id: 1,
      title: "Vegan",
      description: "Our entire collection is vegan and cruelty free.",
      icon: "/images/vegan.avif",
    },
    {
      id: 2,
      title: "Fast & Free Shipping",
      description: "Doorstep delivery to most of the US.",
      icon: "/images/Group.avif",
    },
    {
      id: 3,
      title: "Natural",
      description: "We only use the finest natural ingredients.",
      icon: "/images/natur.avif",
    },
    {
      id: 4,
      title: "Recyclable",
      description: "All packaging is recyclable and eco conscious.",
      icon: "/images/Recyclable.avif",
    },
  ];

  return (
    <section className="features-section">
      <div className="features-inner">
        {features.map((feature) => (
          <div key={feature.id} className="feature-card">
            <div className="icon-box">
              <img src={feature.icon} alt={feature.title} />
            </div>

            <h3 className="feature-title">{feature.title}</h3>
            <p className="feature-desc">{feature.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default HomeFeatures;